import styles from "./index.module.less";
import { connect } from "react-redux";
import { Button, Form, Input } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  LockOutlined,
} from "@ant-design/icons";
import service from "../../@services";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Login = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [$loading, set$loading] = useState(false);
  const { auth } = props;
  useEffect(() => {
    if (auth.authorization) {
      if (location.state && location.state.ref) {
        history.replace("/");
      } else {
        history.replace("/");
      }
    }
  }, [auth.authorization, location.state, history]);
  const onUserlogin = (data) => {
    set$loading(true);
    service.auth
      .login({
        loginType: "pc",
        ...data,
        // password: "Sj123456",
        // username: "ysadmin",
      })
      .catch(() => {
        set$loading(false);
      });
  };
  return (
    <div className={styles.page}>
      <img className={styles.bg} src="/assets/login-bg.jpg" />
      <div className={styles.form}>
        <Form size="large" onFinish={onUserlogin} className={styles.loginPanel}>
          <Form.Item>
            <div className={styles.titleBg}>WELCOME</div>
            <div className={styles.title}>甜橙ERP管理系统</div>
          </Form.Item>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input addonBefore={<UserOutlined />}></Input>
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              addonBefore={<LockOutlined />}
              iconRender={(visible) =>
                visible ? <EyeInvisibleOutlined /> : <EyeOutlined />
              }
            ></Input.Password>
          </Form.Item>
          <Form.Item>
            <div className={styles.tip}>小贴士: 如忘记密码请联系管理员重置</div>
          </Form.Item>
          <Form.Item>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className={styles.loginPanelSubmit}
              loading={$loading}
            >
              立即登录
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default connect((state) => ({ auth: state.auth }))(Login);
